import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginType } from '../../classes/static/enums';
import { LoginService } from '../../services/login.service';
import { BlockedBusinessModalComponent } from '../blocked-business-modal/blocked-business-modal.component';
import { BusinessRegistrationInfoModalComponent } from '../business-registration-info-modal.component/business-registration-info-modal.component';
import { PasswordRetrievalComponent } from '../password-retrieval/password-retrieval.component';

@Component({
	selector: 'business-login-form',
	template: require('./business-login-form.component.html'),
})
export class BusinessLoginFormComponent {
	isFirstStep: boolean = true;
	existingUser: boolean = false;
	@Input() isCorporateUser: boolean = false;
	@Input() isDisabled: boolean = true;
	// @ViewChild('usernameRef') public usernameRef: ElementRef;
	// @ViewChild('passwordRef') public passwordRef: ElementRef;
	// we use this boolean to show the error
	// message when a user is corporate
	//isCorporateUser: boolean = false;
	userId: string = '';
	isPasswordVisible: boolean = false;

	constructor(private modalService: NgbModal, private router: Router) {}

	submitCode(): void {
		this.isFirstStep = false;
	}
	retailSelected() {
		LoginService.setType(LoginType.Retail);
	}

	backToFirstStep() {
		this.isFirstStep = true;
	}

	toggleVisibility() {
		this.isPasswordVisible = !this.isPasswordVisible;
	}

	toggleNewPassword() {
		//   this.modalService.open(CreatePasswordComponent, {
		//     windowClass: "modal-small",
		//   });
	}

	toggleForgetPassword() {
		//   this.modalService.open(MessageModalComponent, {
		//     windowClass: "modal-small",
		//   });
	}

	togglePasswordRetrievalModal() {
		this.modalService.open(PasswordRetrievalComponent, {
			windowClass: 'modal-small',
		});
	}

	toggleBlocked() {
		this.modalService.open(BlockedBusinessModalComponent, {
			windowClass: 'modal-small',
		});
	}
	public toggleBusinessRegistrationInfoModal() {
		this.modalService.open(BusinessRegistrationInfoModalComponent, {
			windowClass: 'modal-small',
		});
	}

	routeRet(): void {}
}
